import { cn } from '@/utils/cn';

const ChatInput = ({
  placeholder,
  className,
  value,
  onChange,
  onSubmit,
  isSure,
}: {
  placeholder: string;
  className?: string;
  value: string;
  isSure?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.nativeEvent.isComposing) {
      return;
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };
  return (
    <form
      className='relative'
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <textarea
        className={cn(
          'block resize-none rounded-s border border-grey-020 bg-grey-010/60 p-4 text-sub3 text-grey-080 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25),_0px_4px_4px_0px_rgba(0,0,0,0.10)_inset] outline-none backdrop-blur-[5px] placeholder:text-grey-020',
          isSure && 'border-none bg-grey-000 text-body2',
          className,
        )}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      <button
        className={cn(
          'absolute bottom-[16px] right-[16px] rounded-s bg-primary-090 px-3 py-1 text-sub4 tracking-m text-grey-000 disabled:bg-grey-020',
          isSure && 'bg-sure-050',
        )}
        type='submit'
        disabled={value.length === 0}
      >
        Send
      </button>
    </form>
  );
};

export default ChatInput;
